/* eslint-disable */
import {
  // Table and Row Management
  SET_SELECTED_ROW,
  SET_API_DATA,
  
  // Loading States
  SET_LOADING,
        
  // Additional Actions
  SET_CURRENT_ROW,
  SET_API_ERROR,
  CLEAR_API_ERROR,
  
  // Root Level Actions
  SET_CURRENT_RENDER_COUNT,
  SET_CONTRACT_API_URL,
} from '../constants/index';

/**
 * Initial state for the request module
 * Contains all state related to request management, filtering, and UI interactions
 */
const initialState = {
  // Table Management
  selectedRow: {},
  apiData: { recordsList: [] },
  currentRow: null,
  
  // Loading States
  loading: false,
  apiError: null,
        
  // UI State
  renderCount: 0,
  tableRef: null,
  
  currentRenderCount: 1,
  contractApiUrl: '',
  instrumentFilter: [],
  
  // Pagination and Sorting
  pageSize: 10,
  pageNumber: 1,
  sortBy: [],
  
  // Additional State
  lastUpdated: null,
  isDirty: false
};

/**
 * Request Reducer
 * Handles all state changes related to request management, filtering, and UI interactions
 * 
 * @param {Object} state - Current state
 * @param {Object} action - Action object with type and payload
 * @returns {Object} New state
 */
const requestReducer = (state = initialState, action) => {
  switch (action.type) {
    // ===== TABLE AND ROW MANAGEMENT =====
    case SET_SELECTED_ROW:
      return {
        ...state,
        selectedRow: action.payload,
      };

    case SET_API_DATA:
      return {
        ...state,
        apiData: action.payload,
        lastUpdated: new Date().toISOString(),
        apiError: null
      };

    // ===== LOADING STATES =====
    case SET_LOADING:
      return {
        ...state,
        loading: action.payload,
      };

       
    // ===== ADDITIONAL STATE MANAGEMENT =====
    case SET_CURRENT_ROW:
      return {
        ...state,
        currentRow: action.payload,
      };

    // ===== ERROR MANAGEMENT =====
    case SET_API_ERROR:
      return {
        ...state,
        apiError: action.payload,
        loading: false
      };

    case CLEAR_API_ERROR:
      return {
        ...state,
        apiError: null
      };

    
    case SET_CURRENT_RENDER_COUNT:
      return {
        ...state,
        currentRenderCount: action.payload,
      };

    case SET_CONTRACT_API_URL:
      return {
        ...state,
        contractApiUrl: action.payload,
      };

    default:
      return state;
  }
};

// Export the reducer as default
export default requestReducer;

// Export initial state for testing purposes
export { initialState };

/**
 * Request Reducer Export
 * 
 * This reducer manages the complete state of the request module including:
 * - Table and row selection management
 * - API data and loading states
 * - Filter and search functionality
 * - Drawer and modal states
 * - Form data management
 * - Error handling
 * 
 * Usage:
 * import requestReducer from './reducers/Request';
 * 
 * State Structure:
 * {
 *   selectedRow: {},           // Currently selected table row
 *   apiData: {},              // API response data
 *   currentRow: null,         // Current active row
 *   loading: false,           // Loading state
 *   apiError: null,          // API error state
 *   drawerOpen: false,        // Drawer open/closed state
 *   requestId: '',           // Current request ID
 *   currentFilters: {},       // Applied filters
 *   filterFormData: {},       // Form data for filters
 *   renderCount: 0,          // Render counter
 *   tableRef: null,          // Table reference
 *   pageSize: 10,            // Pagination size
 *   pageNumber: 1,           // Current page
 *   sortBy: [],              // Sort configuration
 *   lastUpdated: null,       // Last update timestamp
 *   isDirty: false           // State change indicator
 * }
 */